const localApiPort = '8090';

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

const configuredApiBaseUrl = () =>
  trimTrailingSlash(String(import.meta.env.VITE_BASE_URL || '').trim());

const isLocalHost = (host: string) =>
  ['localhost', '127.0.0.1', '0.0.0.0', '::1'].includes(host);

const hostFromUrl = (value: string) => {
  try {
    return new URL(value).hostname;
  } catch {
    return value.replace(/^[a-z]+:\/\//i, '').split('/')[0]?.split(':')[0] || '';
  }
};

const localDevelopmentApiBaseUrl = () => {
  const pageHost = window.location.hostname;
  if (!pageHost || isLocalHost(pageHost)) return '';

  return `${window.location.protocol}//${pageHost}:${localApiPort}`;
};

export const resolveApiBaseUrl = () => {
  const configured = configuredApiBaseUrl();
  if (!configured) return localDevelopmentApiBaseUrl() || window.location.origin;

  const configuredHost = hostFromUrl(configured);
  if (isLocalHost(configuredHost)) {
    return localDevelopmentApiBaseUrl() || configured;
  }

  return configured;
};

export const resolveWebSocketBaseUrl = () =>
  resolveApiBaseUrl()
    .replace(/^http/i, 'ws')
    .replace(/\/$/, '');
